import { createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { ShareableInfo } from 'interfaces/share'

export const REGISTER_SHARE = 'REGISTER_SHARE' as const
type RegisterShare = PayloadAction<typeof REGISTER_SHARE, ShareableInfo>
export const registerShareActionCreator = (shareable: ShareableInfo): RegisterShare =>
  createPayloadAction(REGISTER_SHARE, shareable)

export type SocialActions = RegisterShare

export default SocialActions
